import * as ngCore from '@angular/core'
import type * as ents from '@attain-apps/entities'
import type * as rxjs from 'rxjs'

import type { Context } from '../../types'

import * as gql from './gql'

/** Space record survey status API (sign off and unlock) */
@ngCore.Injectable()
export class Api {
  /**
   * Signs off the given space record. Resolves with the ids that were
   * actually signed off, which may be empty if the record didn't meet the
   * requirements to be signed off.
   */
  public signOff({
    context,
    spaceRecordId,
  }: Api.Input): rxjs.Observable<readonly ents.extra.space.Record.Id[]> {
    return gql.mutations.signOff.executor({
      ...context,
      spaceRecordIds: [spaceRecordId],
    })
  }

  /**
   * Unlocks the given space record's survey. Resolves with the ids that were
   * actually unlocked.
   */
  public unlock({
    context,
    spaceRecordId,
  }: Api.Input): rxjs.Observable<readonly ents.extra.space.Record.Id[]> {
    return gql.mutations.unlock.executor({
      ...context,
      spaceRecordIds: [spaceRecordId],
    })
  }
}

export namespace Api {
  export interface Input {
    readonly context: NonNullable<Context>
    readonly spaceRecordId: ents.extra.space.Record.Id
  }
}
